import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import Immutable from 'immutable';
import classnames from 'classnames';
import $ from 'jquery';
import _ from 'underscore';
import { QueryProvider } from '@anyroad/providers';

import './index.scss';

import SessionStore from 'stores/shared/session';
import { t, loadLocales } from 'services/translation';
import Dimmer from 'views/shared/ui/dimmer';
import FormController from 'lib/form/controller';
import { isStripeFieldsCompleted } from 'lib/form/stripe_fields';

import BookingRequestActionCreator from 'action_creators/booking_request';
import PaymentError from 'views/plugins/global_error/PaymentError';
import IntegrationActionCreator from 'action_creators/integration';
import BookingRequestStore from 'stores/plugins/booking_request';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import validations from 'views/plugins/booking_request/validations/checkout';
import PricingStore from 'stores/plugins/pricing';
import PricingActionCreator from 'action_creators/pricing';
import GoogleTranslate from 'views/ui/google_translate';
import ModalActionCreator from 'action_creators/modal';
import { CheckoutError } from 'views/plugins/global_error/CheckoutError';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import {
  getFormattedAffiliateGuests,
  formatBookerGuestName,
} from 'views/plugins/checkout/guest_information/Helpers';
import AffiliatePaymentSelector from 'views/anyguide/affiliates/components/AffiliatePaymentSelector';

// OLD CHECKOUT COMPONENTS
import Summary from '../summary';

// NEW MOBILE FIRST CHECKOUT COMPONENTS
import { BookingTimer } from './booking_timer';
import { GuestInformation } from './guest_information';
import { Header, PartnerHeader } from './header';
import { PersonalInformation } from './personal_information';
import { Discount } from './discount';
import { AdditionalInformation } from './additional_information';
import { PoweredBy } from './powered-by';

import { MessageGuide } from './message-guide';
import { PrivacyPolicy } from './privacy_policy';

import { Payment } from './payment';

import { LanguageHeader, LanguageSelector } from '../default/header';
import { PaymentStepHeader } from '../payment/PaymentStepHeader';
import { isGuestOnList } from '../api';
import { triggerStripe3dsScroll } from '../utils/scroll_utils';
import { getUtmParams } from '../utils/url_params';

const MobileFirstCheckoutPage = createReactClass({
  displayName: 'MobileFirstCheckoutPage',
  mixins: [FormController, StoreInterestMixin],
  i18n: null,

  propTypes: {
    initial_summary_props: PropTypes.object.isRequired,
    initial_fully_discounted: PropTypes.bool.isRequired,
    initial_fields: PropTypes.object.isRequired,
    tour_id: PropTypes.number,
    booking_request_id: PropTypes.string.isRequired,
    includes_transport: PropTypes.bool,
    tour_settings: PropTypes.object,
    units: PropTypes.object,
    managed_account_token: PropTypes.string,
    is_ga4_enabled: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      includes_transport: false,
      tour_settings: {},
    };
  },

  getInitialState() {
    return {
      summary_props: Immutable.Map(this.props.initial_summary_props),
      fields: Immutable.Map(this.props.initial_fields),
      errors: Immutable.Map({}),
      loading: false,
      discountLoading: false,
      discountApplied:
        this.props.initial_summary_props.request.discount_applied,
      fully_discounted: this.props.initial_fully_discounted,
      zero_priced_tour: null,
      committed: false,
      total: 1, // So that billing section doesn't flicker on mount
      tour_id: 1,
      guests: 0,
      tour_name: '',
      privacy_policy_link: '',
      privacy_policy_link_text: '',
      hide_policy_links: false,
      currency: '',
      unit_price: 0,
      unit_price_for_initial_pricing: 0,
      total_without_service_fee: 0,
      units: [],
      paid_in_cash: null,
      phone_mandatory: null,
      stripe: { fieldsCompleted: [] },
      bookerUnitId: null,
      i18n_lang: this.i18n,
      isPayLaterSelected: false,
      selectedPaymentType: '',
      is_ga4_enabled: this.props.is_ga4_enabled,
      units_and_addons_detail: '',
      selected_addons_with_count: [],
      stripeAuthLoading: false,
      stripeAuthAttempted: false,
    };
  },

  getStoreInterests() {
    return {
      errors: 'booking_request.errors',
      loading: 'booking_request.loading',
      committed: 'booking_request.committed',
      requiresAuth: 'booking_request.requiresAuth',
      authCompleted: 'booking_request.authCompleted',
      stripeCardElement: 'booking_request.stripeCardElement',
      customerSecret: 'booking_request.customerSecret', // pragma: allowlist secret
      paymentId: 'booking_request.paymentId', // this is a Payment::Base id, not a stripe id
      phone_mandatory: 'booking_request.phone_mandatory',
      discountApplied: 'booking_request.discountApplied',
      summary_props: 'booking_request.summary_props',
      discountLoading: 'booking_request.discountLoading',
      fully_discounted: 'booking_request.fully_discounted',
      tour_id: 'booking_request.tour_id',
      tour_name: 'pricing.tour_name',
      privacy_policy_link: 'pricing.privacy_policy_link',
      privacy_policy_link_text: 'pricing.privacy_policy_link_text',
      hide_policy_links: 'pricing.hide_policy_links',
      zero_priced_tour: 'pricing.zero_priced',
      paidInFull: 'booking_request.paidInFull',
      total: 'pricing.total',
      guests: 'pricing.guests',
      currency: 'pricing.currency',
      unit_price: 'pricing.unit_price',
      paid_in_cash: 'pricing.paid_in_cash',
      unit_price_for_initial_pricing: 'pricing.unit_price_for_initial_pricing',
      total_without_service_fee: 'pricing.total_without_service_fee',
      units_and_addons_detail: 'pricing.units_and_addons_detail',
      selected_addons_with_count: 'pricing.selected_addons_with_count',
    };
  },

  UNSAFE_componentWillMount() {
    this.i18n =
      SessionStore.state.get('i18n') ||
      (this.props.tour && this.props.tour.i18n_locale);
    loadLocales(this.i18n);
    this.updateLangParams();
  },

  componentDidMount() {
    const isInIframe = window !== window.top;
    this._refreshPricing();

    PricingStore.changed.add(this._pricingChanged);
    BookingRequestStore.changed.add(this._refreshPricing);
    this._setSelectedPaymentType();

    if (isInIframe) {
      IntegrationActionCreator.startScrollingIntercom();
    }
  },

  componentDidUpdate(prevProps, prevState) {
    const { unit_price, requiresAuth, stripeAuthLoading, stripeAuthAttempted } =
      this.state;

    // Reset stripeAuthAttempted when auth state is reset
    if (prevState.requiresAuth && !requiresAuth) {
      this.setState({ stripeAuthAttempted: false });
    }

    if (
      this.state.tour_name !== (null || '' || prevState.tour_name) &&
      unit_price !== null
    ) {
      try {
        googleTagManagerAddToCart(this._googleTagMangerBookingDetails());
        googleTagManagerCheckout(this._googleTagMangerBookingDetails(), 1);
      } catch (error) {
        console.log('google tag error', error);
      }
    }
    const { is_booking_invoice } = this.props;

    if (
      this._hasTransitionedToInvalid(prevState) ||
      this._hasTransitionedToLoading(prevState)
    ) {
      $(window).scrollTop(is_booking_invoice ? 100 : 0);
    } else if (
      this._requiresAuth() &&
      !stripeAuthLoading &&
      !stripeAuthAttempted
    ) {
      triggerStripe3dsScroll();
      this.handleStripeAuth();
    } else if (this._readyForConfirmation()) {
      const langParam = this.i18n ? `&lang=${this.i18n}` : '';
      const utmParams = getUtmParams();
      /* payments path shows partner branding on standalone (non-plugin) payment flows */

      let confirmationUrl;

      if (this._isLiveBooking()) {
        confirmationUrl = `/live/${this.props.booking_request_id}/confirmation?${langParam}&${utmParams}`;
      } else if (is_booking_invoice) {
        confirmationUrl = `/payments/${this.props.booking_request_id}/confirmation?${langParam}`;
      } else {
        confirmationUrl = `/booking_request/confirmation?id=${
          this.props.booking_request_id
        }${langParam}${this._getCuratedToursListParam()}${this._getPluginParam()}`;
      }

      window.location = confirmationUrl;
    }
  },

  componentWillUnmount() {
    PricingStore.changed.remove(this._pricingChanged);
    BookingRequestStore.changed.remove(this._refreshPricing);
    if (window !== top) {
      IntegrationActionCreator.stopScrollingIntercom();
    }
  },

  _googleTagManagerCheckoutProgress(step) {
    try {
      googleTagManagerCheckout(this._googleTagMangerBookingDetails(), step);
    } catch (error) {
      console.log('google tag error', error);
    }
  },

  _setSelectedPaymentType() {
    const { is_pay_later_enabled, is_outside_pay_later_cutoff } = this.props;
    const selectedPaymentType =
      is_pay_later_enabled && is_outside_pay_later_cutoff
        ? 'pay-later'
        : 'charge-card';
    this._onSelectPaymentType(selectedPaymentType);
  },

  _googleTagMangerBookingDetails() {
    const {
      currency,
      guests,
      tour_name,
      total,
      unit_price,
      is_ga4_enabled,
      unit_price_for_initial_pricing,
      total_without_service_fee,
      units_and_addons_detail,
    } = this.state;
    const { tour_id } = this.props;
    const formattedCurrency = currency && currency.toUpperCase();
    const bookingDetails = {
      guests,
      tour_id,
      tour_name,
      unit_price,
      is_ga4_enabled,
      currency: formattedCurrency,
      total_price: total,
      unit_price_for_initial_pricing,
      total_without_service_fee,
      units_and_addons_detail: units_and_addons_detail.toJS(),
    };

    return bookingDetails;
  },

  _getPricingParams() {
    const { booking_id, time } = this.props.initial_summary_props.request;
    const params = booking_id ? { bookingId: booking_id } : {};

    // Add time from server-rendered props if available
    if (time) {
      params.time = time;
    }

    return params;
  },

  handleStripeAuth() {
    this.setState({ stripeAuthAttempted: true, stripeAuthLoading: true });
    PricingStore.changed.remove(this._pricingChanged);
    BookingRequestStore.changed.remove(this._refreshPricing);
    try {
      stripe
        .handleCardPayment(
          this.state.customerSecret,
          this.state.stripeCardElement
        )
        .then((result) => {
          this.setState({ stripeAuthLoading: false });
          PricingStore.changed.add(this._pricingChanged);
          BookingRequestStore.changed.add(this._refreshPricing);
          if (result.error) {
            BookingRequestActionCreator.setStripePaymentError(
              result.error.message
            );
          } else {
            const { status } = result.paymentIntent;
            const params = {
              id: this.state.paymentId,
              status,
            };
            BookingRequestActionCreator.completeAuth(params);
          }
        })
        .catch((error) => {
          this.setState({ stripeAuthLoading: false });
          PricingStore.changed.add(this._pricingChanged);
          BookingRequestStore.changed.add(this._refreshPricing);
          console.log(error);
        });
    } catch (error) {
      this.setState({ stripeAuthLoading: false });
      PricingStore.changed.add(this._pricingChanged);
      BookingRequestStore.changed.add(this._refreshPricing);
      console.log(error);
    }
  },

  _getCuratedToursListParam() {
    // Returns name of CTL if plugin is in that context
    const ctlName = new URLSearchParams(window.location.search).get('ctl_name');
    return ctlName ? `&ctl_name=${ctlName}` : '';
  },

  _getPluginParam() {
    // Returns slug of Plugin if in that context
    const plugin = new URLSearchParams(window.location.search).get('plugin');
    return plugin ? `&plugin=${plugin}` : '';
  },

  _pricingChanged() {
    const units = PricingStore.state.get('units').toJS().items;
    const bookerUnit = units?.find((unit) => unit.count > 0);

    this.setState({
      total: parseFloat(PricingStore.state.get('total')),
      units,
      bookerUnitId: this.state.bookerUnitId || bookerUnit?.id,
    });
  },

  _refreshPricing() {
    if (!this.state.loading && !this.state.commmited) {
      const params = this._getPricingParams();
      PricingActionCreator.preview(params);
    }
  },

  _readyForConfirmation() {
    const { authCompleted, paidInFull, committed } = this.state;
    const { is_unpaid_booking: unpaidBooking, is_live: isLive } = this.props;
    if (authCompleted || paidInFull) return true;
    if (committed && isLive) return true;

    return committed && !unpaidBooking;
  },

  _requiresAuth() {
    return this.state.requiresAuth === true && !this.state.authCompleted;
  },

  _hasTransitionedToLoading(prevState) {
    return prevState.loading === false && this.state.loading === true;
  },

  _hasTransitionedToInvalid(prevState) {
    /* If the error is a discount one, we don't want to scroll to
     * the top of the page. Since the checkout form uses the same
     * store and `errors` object as the discount component, this is
     * the easiest way to do this. Otherwise we would have to create
     * a different `discountErrors` object in the store and use that
     * for everything discount-related.
     */
    return (
      prevState.errors !== this.state.errors &&
      this.state.errors.toJS().discount_code === undefined
    );
  },

  _additionalSubmitParams() {
    return {
      tour_id: this.props.tour_id,
      id: this.props.booking_request_id,
    };
  },

  _discountProps() {
    return {
      additionalParams: this._additionalSubmitParams(),
      discountApplied: this.state.discountApplied,
      errors: this.state.errors.get('discount_code'),
      discountLoading: this.state.discountLoading,
      borderless: !this._shouldShowAdditionalInfo() && !this.props.is_affiliate,
      onApplyDiscount: this._handleApplyDiscount,
      onRemoveDiscount: this._handleRemoveDiscount,
    };
  },

  _handleApplyDiscount(params) {
    BookingRequestActionCreator.applyDiscount(params);
  },

  _handleRemoveDiscount(params) {
    BookingRequestActionCreator.removeDiscount(params);
  },

  _numOfGuests() {
    return this.props.units.reduce((a, e) => {
      return a + e.count;
    }, 0);
  },

  _additionalInformationProps() {
    return {
      showQuestions: this._shouldShowQuestions(),
      showWaiver: this._shouldShowWaiver(),
      waiverProps: this._waiverProps(),
      questionsProps: this._questionsProps(),
      stepNo: this._getAdditionalInfoStepNo(),
      isLiveBooking: this._isLiveBooking(),
    };
  },

  _getAdditionalInfoStepNo() {
    const { zero_priced_tour } = this.state;
    const { is_booking_invoice } = this.props;
    const disabledPayment = zero_priced_tour || this._shouldDisablePayment();

    if (
      (disabledPayment && !this._shouldCollectGuestInfo()) ||
      !this._shouldShowPersonalSection()
    ) {
      return 2;
    }
    if (
      !disabledPayment &&
      this._shouldCollectGuestInfo() &&
      !is_booking_invoice
    ) {
      return 4;
    }
    return 3;
  },

  _questionsProps() {
    return {
      questions: this.props.initial_fields.checkout_questions,
      onChange: this._checkoutQuestionInputChanged,
      googleTagManagerCheckoutProgress: this._googleTagManagerCheckoutProgress,
    };
  },

  _additionalGuestsProps() {
    const { fields, units } = this.state;
    const { integration_brand_color } = this.props.partner_info;
    const { first_name: firstName, last_name: lastName } = fields.toJS();
    const bookerGuestName = formatBookerGuestName({ firstName, lastName });

    return {
      bookerGuestName,
      isGuestOfGuestEnabled: this.props.is_guest_of_guest_enabled,
      numOfGuests: this._numOfGuests(),
      onChange: this._additionalGuestInputChanged,
      lastSection: this._isGuestSectionLast(),
      units,
      unitsLoaded: this.state.units?.length > 0,
      brandColor: integration_brand_color,
    };
  },

  _isGuestSectionLast() {
    return !!this._shouldShowPayment() || !!this._shouldShowAdditionalInfo();
  },

  _checkoutQuestionInputChanged(position, value) {
    const stateFields = this.state.fields.toJS();
    const checkoutQuestions = stateFields.checkout_questions;

    const question = checkoutQuestions.find(
      (question) => question.position === position
    );
    question.answer = value;
    this.setState({ fields: Immutable.Map(stateFields) });
  },

  _additionalGuestInputChanged(position, value, nameField, unitTypeId) {
    if (position === 'bookerUnitId') {
      this.setState({ bookerUnitId: value });
      return;
    }
    const stateFields = this.state.fields.toJS();
    const additionalGuests = stateFields.additional_guests;
    let guest = additionalGuests.find((g) => g.position === position);

    if (typeof guest === 'undefined') {
      guest = { [nameField]: value, position, unit_type_id: unitTypeId };
      additionalGuests.push(guest);
    } else {
      guest[nameField] = value;
      guest.unit_type_id = unitTypeId;
    }
    this.setState({ fields: Immutable.Map(stateFields) });
  },

  _shouldShowWaiver() {
    const { is_affiliate: isAffiliate } = this.props;
    return !isAffiliate && this._waiverProps().required;
  },

  _shouldShowAdditionalInfo() {
    const { is_affiliate: isAffiliate } = this.props;
    return (
      !isAffiliate &&
      (!!this._shouldShowQuestions() || !!this._shouldShowWaiver())
    );
  },

  _waiverProps() {
    return this.props.initial_summary_props.request.tour_waiver_info;
  },

  _summaryProps() {
    return _.extend({}, this.state.summary_props.toJS(), {
      tour_id: this.props.tour_id,
      is_booking_invoice: this.props.is_booking_invoice,
    });
  },

  // Either a regular invoice, anyroad live, or a booking invoice that is a direct link shared w guest
  _paymentOnlyFlow() {
    return (
      this._bookingRequestProps().is_invoice ||
      this._bookingRequestProps().invoiceable
    );
  },

  _fieldsToHide() {
    const fieldsToHide = [];
    if (this._isLiveBooking()) return fieldsToHide;
    if (this._paymentOnlyFlow() && this._bookingRequestProps().email) {
      fieldsToHide.push('email');
    }
    if (this._paymentOnlyFlow()) {
      fieldsToHide.push('name');
    }
    return fieldsToHide;
  },

  _personalProps() {
    const {
      initial_summary_props: initialSummaryProps,
      is_booking_invoice,
      is_affiliate: isAffiliate,
      initial_fields: initialFields,
    } = this.props;

    const { zero_priced_tour: zeroPricedTour } = this.state;

    return this._formProxyProps('personal', {
      is_booking_invoice,
      phoneMandatory: this._shouldValidatePhone(),
      emailSubtext: initialSummaryProps.request.email_subtext,
      phoneSubtext:
        initialSummaryProps.request.phone_subtext ||
        `${t(
          'BY_PROVIDING_TOUR_PHONE_NUMBER_YOU_AGREE_TO_RECEIVE_SMS_MESSAGES_RELATED_TO_THIS_BOOKING'
        )}`,
      fieldRequirementsSubtext:
        initialSummaryProps.request.field_requirements_subtext,
      borderless:
        zeroPricedTour === null ||
        (zeroPricedTour && !this._shouldCollectGuestInfo()),
      fieldsToHide: this._fieldsToHide(),
      countryCode: initialFields.billing_country,
      isLiveBooking: this._isLiveBooking(),
      showZipCodeOnLive:
        initialSummaryProps?.request?.live?.activate_zip_code_field,
      googleTagManagerCheckoutProgress: this._googleTagManagerCheckoutProgress,
      isAffiliate,
    });
  },

  _privacyPolicyProps() {
    const { privacy_policy_link, privacy_policy_link_text } = this.state;
    return this._formProxyProps('additional_information', {
      privacy_policy_link,
      privacy_policy_link_text,
    });
  },

  _messageGuideProps() {
    const { initial_summary_props } = this.props;
    const { request } = initial_summary_props;
    const { for_custom_booking } = request;
    return this._formProxyProps('message', {
      guideName: this.props.initial_summary_props.request.guide_full_name,
      borderless: false,
      showHint: this.props.includes_transport,
      noMobilePadding: for_custom_booking,
    });
  },

  async validateGuest(params) {
    const { email } = params;
    const { tour_id: tourId } = this.props;
    const guestAllowed = await isGuestOnList(tourId, email);

    if (guestAllowed) {
      this.submitForm(params);
    } else {
      this.setState((prevState) => ({
        errors: prevState.errors.set(
          'email',
          Immutable.List.of(t('RESTRICTED_BOOKING_EMAIL_ERROR')) // pragma: allowlist secret
        ),
      }));
    }
  },

  async submitForm(params) {
    this.setState({ loading: true });
    const { units, selected_addons_with_count: selectedAddons } = this.state;
    const { is_affiliate: isAffiliate } = this.props;

    // Creates token for stripe to ensure most recent card details are used
    const { fieldsCompleted = [] } = this.state.stripe || {};
    if (isStripeFieldsCompleted(fieldsCompleted)) {
      await stripe.createToken(this.state.stripeCardElement).then((result) => {
        const { stripe } = this.state;
        if (result.token) {
          BookingRequestActionCreator.setStripeToken(result.token.id);
          this.setState({
            stripe: {
              ...stripe,
              token: result.token.id,
            },
          });
        } else if (result.error) {
          this.setState({
            stripe: {
              ...stripe,
              error: result.error,
            },
          });
        }
      });
    }

    const stripeToken = (this.state.stripe && this.state.stripe.token) || null; // REMOVE WHEN TOKEN STATE IS FIXED

    params.checkout_questions = this._flattenMultipleCheckoutAnswers(params);
    params.unit_configuration = this.props.units;
    params.addon_configuration = selectedAddons;

    if (isAffiliate) {
      params.additional_guests = getFormattedAffiliateGuests(units);
    } else {
      params.additional_guests = this._formatAdditionalGuests(params);
    }

    // Remove when we transition to guest of guest api
    params.booker_unit_id = this.state.bookerUnitId;
    params.i18n = this.i18n;
    BookingRequestActionCreator.commit({
      ...params,
      stripe_token: stripeToken,
    });
  },

  async formSubmitted(params) {
    const {
      is_rsvp_enabled: isRsvpEnabled,
      is_booking_invoice: isBookingInvoice,
    } = this.props;
    // Handle restricted bookings (RSVP list)
    if (isRsvpEnabled && !isBookingInvoice) {
      this.validateGuest(params);
    } else {
      this.submitForm(params);
    }
  },

  // XXX duplicated with frontend/components/views/plugins/checkout/mobile/helpers.js
  // Maybe extract to shared helper
  _formatAdditionalGuests(params) {
    params.additional_guests.forEach((guest) => {
      const firstName = guest.first_name ? `${guest.first_name} ` : '';
      const lastName = guest.last_name ? guest.last_name : '';
      guest.full_name = firstName + lastName;
    });
    return params.additional_guests;
  },

  _flattenMultipleCheckoutAnswers(params) {
    // we are only permitting the tour_question_id and answers on the backend
    const answers = [];

    params.checkout_questions.forEach((question) => {
      if (Array.isArray(question.answer)) {
        // Remove null values from array
        const questionAnswer = question.answer.filter((ans) => ans);
        questionAnswer.forEach((answer) => {
          const singleAnswer = {
            tour_question_id: question.tour_question_id,
            answer,
          };
          answers.push(singleAnswer);
        });
      } else {
        answers.push({
          tour_question_id: question.tour_question_id,
          answer:
            question.input_type === 'waiver' && !question.answer
              ? 'no'
              : question.answer,
        });
      }
    });
    return answers;
  },

  validationConstraints() {
    const { is_affiliate: isAffiliate } = this.props;
    let validationsToApply = validations;

    if (this._skipPaymentValidations()) {
      // Don't validate payment section if fully discounted or tour price is 0
      validationsToApply = _.omit.apply(
        null,
        _.union([validationsToApply], this.formSections.payment, ['stripe'])
      );
    } else {
      _.extend(validationsToApply, { stripe: true });
    }

    if (!this._shouldShowWaiver()) {
      // Don't validate waiver if it is not enabled
      _.extend(validationsToApply, { waiver_accepted: {} });
    }

    if (!this._shouldShowQuestions() || isAffiliate) {
      // Don't validate checkout questions if not enabled
      _.extend(validationsToApply, { checkout_questions: {} });
    }

    if (!this._shouldCollectGuestInfo()) {
      // Don't validate guest_info questions if not enabled
      _.extend(validationsToApply, { additional_guests: {} });
    }

    if (!this._shouldValidatePrivacyPolicy()) {
      // Don't validate guide privacy policy if not enabled
      _.extend(validationsToApply, { privacy_policy_accepted: {} });
    }

    // LIVE validation expansion
    if (this._isLiveBooking()) {
      // email
      if (!this._liveSettings().guest_email_required) {
        _.extend(validationsToApply, { email: { email: true } });
      }
      if (this._liveSettings().activate_zip_code_field) {
        _.extend(validationsToApply, {
          zip_code: { presence: { allowEmpty: false } },
        });
      }

      // phone
      const phoneValidation = this._liveSettings().guest_phone_required
        ? { presence: true }
        : {};
      _.extend(validationsToApply, { phone: phoneValidation });
    } else if (!this._shouldValidatePhone()) {
      // Don't validate phone if not enabled
      _.extend(validationsToApply, { phone: {} });
    }

    if (!this._shouldShowPersonalSection()) {
      // Don't validate personal information if it is hidden
      _.extend(validationsToApply, {
        first_name: {},
        last_name: {},
        email: {},
        phone: {},
      });
    }

    if (isAffiliate) {
      _.extend(validationsToApply, { email: {} });
    }

    return validationsToApply;
  },

  _bookingRequestProps() {
    return this.state.summary_props.get('request') || {};
  },

  _skipPaymentValidations() {
    const { isPayLaterSelected, total, paid_in_cash } = this.state;
    return (
      isPayLaterSelected || total === 0 || paid_in_cash || this._isLiveBooking()
    );
  },

  _shouldDisablePayment() {
    return this.state.paid_in_cash || this.state.fully_discounted;
  },

  _shouldDisableDiscount() {
    return (
      !this._shouldShowPayment() ||
      this.state.paid_in_cash ||
      this.state.isPayLaterSelected
    );
  },

  _shouldShowQuestions() {
    const checkoutQuestions = this.props.initial_fields.checkout_questions;
    return checkoutQuestions && !!checkoutQuestions.length;
  },

  _shouldCollectGuestInfo() {
    const {
      is_guest_of_guest_enabled,
      guest_of_guest_max_guests,
      is_affiliate,
    } = this.props;
    const ignoreMaxGuest =
      guest_of_guest_max_guests === 0
        ? true
        : this._numOfGuests() <= guest_of_guest_max_guests;
    return (
      !is_affiliate &&
      is_guest_of_guest_enabled &&
      this._numOfGuests() > 1 &&
      ignoreMaxGuest
    );
  },

  _shouldValidatePrivacyPolicy() {
    const { is_affiliate: isAffiliate, is_unpaid_booking: isUnpaidBooking } =
      this.props;
    const {
      privacy_policy_link: privacyPolicyLink,
      privacy_policy_link_text: privacyPolicyLinkText,
    } = this.state;
    const affiliatePayLaterCheckout = isAffiliate && isUnpaidBooking;

    return (
      privacyPolicyLink && privacyPolicyLinkText && !affiliatePayLaterCheckout
    );
  },

  _shouldValidatePhone() {
    const { initial_summary_props } = this.props;
    let { phone_mandatory } = initial_summary_props.request;
    if (this._isLiveBooking())
      phone_mandatory = this._liveSettings().guest_phone_required;
    return phone_mandatory;
  },

  // ========== LIVE
  _liveSettings() {
    return this.props.initial_summary_props.request.live;
  },

  _isLiveBooking() {
    const { request } = this.props.initial_summary_props;
    return request.is_live_booking && this._liveSettings().enabled;
  },

  // ==========

  formSections: {
    personal: [
      'first_name',
      'last_name',
      'email',
      'phone',
      'cardholder_first_name',
      'cardholder_last_name',
      'guest_invoiced',
      'is_live_booking',
      'zip_code',
    ],
    payment: [
      'cardholder_first_name',
      'cardholder_last_name',
      'cardNumber',
      'cardExpiry',
      'cardCvc',
      'billing_address_line_1',
      'billing_address_line_2',
      'billing_country',
      'billing_city',
      'billing_region',
      'billing_zip_code',
      'postalCode',
    ],
    additional_information: [
      'waiver_accepted',
      'checkout_questions',
      'additional_guests',
      'anyroad_privacy_policy',
      'privacy_policy_accepted',
      'is_pay_later_selected',
    ],
    message: ['message'],
  },

  _renderSubmitButtonLabel(isInvoice) {
    const settings = this.props.tour_settings;
    if (!settings) return t('SUBMIT');
    const label = settings.submit_booking_label.value;

    let submitLabel =
      label === 'Confirm Purchase'
        ? t('Confirm Purchase')
        : label || t('CONFIRM_PURCHASE');

    if (isInvoice) {
      submitLabel = settings.submit_invoice_label.value;
    } else if (this._isLiveBooking()) {
      submitLabel = t('REGISTER');
    }
    return submitLabel;
  },

  _renderSubmitButton() {
    const { is_affiliate } = this.props;
    const className = classnames('ui red button brand-bg', {
      loading: this._renderLoading(),
    });

    const isInvoice = this._bookingRequestProps().is_invoice;
    return (
      <div className="ButtonContainer">
        <button
          data-testid="checkout-submit"
          type="button"
          className={className}
          onClick={this.onSubmit}
          onKeyDown={(e) => isActionKey(e.key) && this.onSubmit}
        >
          {this._renderSubmitButtonLabel(isInvoice)}
        </button>
      </div>
    );
  },

  _renderGoogleTranslate() {
    return <GoogleTranslate enabled={false} />;
  },

  _shouldShowPayment() {
    const { zero_priced_tour } = this.state;
    return zero_priced_tour !== null && !zero_priced_tour;
  },

  _shouldShowPayLater() {
    const { zero_priced_tour } = this.state;
    const { is_pay_later_enabled, is_unpaid_booking } = this.props;

    return (
      zero_priced_tour !== null &&
      !zero_priced_tour &&
      is_pay_later_enabled &&
      !is_unpaid_booking
    );
  },

  _shouldShowPersonalSection() {
    return this.props.is_guest_info_collection_enabled;
  },

  _renderPartnerHeader() {
    const {
      partner_info: {
        business_name: businessName,
        logo,
        brand_color: brandColor,
      },
      is_booking_invoice: isBookingInvoice,
      is_affiliate: isAffiliate,
      is_unpaid_booking: isUnpaidBooking,
    } = this.props;
    const affiliatePayLaterCheckout = isAffiliate && isUnpaidBooking;

    if (
      (!isBookingInvoice && !this._isLiveBooking()) ||
      affiliatePayLaterCheckout
    )
      return null;

    return (
      <PartnerHeader
        isLiveHeader={this._isLiveBooking()}
        hideOnMobile
        bgColor={brandColor}
        title={businessName}
        logo={logo}
      />
    );
  },

  _renderLoading() {
    const { loading, stripeAuthLoading } = this.state;
    return loading || stripeAuthLoading || this._readyForConfirmation();
  },

  renderPaymentError() {
    ModalActionCreator.show({
      content: (
        <PaymentError
          errorMessage={this.state.errors.get('stripePaymentError')}
        />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: true },
      showIcon: true,
    });
    BookingRequestActionCreator.resetStripeAuth();
  },

  renderAddonsError() {
    const {
      initial_summary_props: {
        request: { origin_url },
      },
    } = this.props;

    const title = `${t('OOPS')}.`;
    const message = `${t(
      'SOMETHING_WENT_WRONG_WHEN_TRYING_TO_PROCESS_YOUR_REQUEST'
    )}.`;
    const secondaryMessage = `${t('PLEASE_REFRESH_YOUR_PAGE_AND_TRY_AGAIN')}.`;

    ModalActionCreator.show({
      content: (
        <CheckoutError
          title={title}
          message={message}
          secondaryMessage={secondaryMessage}
          buttonUrl={origin_url}
        />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: false,
    });
  },

  updateLangParams() {
    const url = new URL(window.location);
    url.searchParams.set('lang', this.i18n);
    window.history.pushState({}, '', url);
  },

  getEnabledLanguages() {
    const { request } = this.props.initial_summary_props;
    return request.i18n_list;
  },

  languageOptions() {
    const languageNames = {
      'en-US': 'English',
      'es-ES': 'Español',
      'sv-SE': 'Svenska',
      'fr-CA': 'Français (Canada)',
      'fr-FR': 'Français (France)',
      'de-DE': 'Deutsch',
      'nl-NL': 'Nederlands',
      'zh-CN': 'Chinese',
      'el-GR': 'Greek',
      'it-IT': 'Italian',
    };
    const englishOption = {
      value: 'en-US',
      label: languageNames['en-US'],
    };

    const enabledLanguages = this.getEnabledLanguages();
    const options = enabledLanguages.map((language) => ({
      value: language,
      label: languageNames[language],
    }));

    return [englishOption, ...options];
  },

  onLanguageChange(data) {
    this.setState({ i18n_lang: data.value, loading: true });
    this.i18n = data.value;
    loadLocales(data.value);
    this.updateLangParams();
    window.location.reload();
  },

  languageValue() {
    let option = this.languageOptions().find(
      (language) => language.value === this.i18n
    );
    if (!option) {
      option = this.languageOptions().find(
        (language) => language.value === 'en-US'
      );
    }
    return option;
  },

  _onSelectPaymentType(paymentType) {
    const fields = this.state.fields.toJS();
    const errors = this.state.errors.toJS();
    const isPayLaterSelected = paymentType === 'pay-later';
    fields.is_pay_later_selected = isPayLaterSelected;

    const paymentSections = this.formSections.payment;
    paymentSections.forEach((ps) => delete errors[ps]);

    this.setState({
      fields: Immutable.Map(fields),
      errors: Immutable.Map(errors),
      selectedPaymentType: paymentType,
      isPayLaterSelected,
    });
  },

  _paymentSubtext() {
    const { initial_summary_props } = this.props;
    const { request } = initial_summary_props;
    const { isPayLaterSelected } = this.state;

    if (isPayLaterSelected) {
      return null;
    }

    if (request.payment_subtext) {
      return (
        <div
          className="contains-brand-link payment-subtext form-details"
          dangerouslySetInnerHTML={{ __html: request.payment_subtext }}
        />
      );
    }
    return <p className="form-details">{t('PCI_INFO')}</p>;
  },

  _paymentSectionStepNumber() {
    const { is_booking_invoice } = this.props;
    if (this._shouldCollectGuestInfo() && !is_booking_invoice) {
      return '3';
    }
    if (!this._shouldShowPersonalSection()) {
      return '1';
    }
    return '2';
  },

  render() {
    const {
      initial_summary_props,
      is_booking_invoice: isBookingInvoice,
      managed_account_token,
      stripe_theme,
      partner_info,
      kiosk_setting,
      tour_id,
      initial_summary_props: {
        request: { guide_id, origin_url },
      },
      is_affiliate,
      will_expire_on: willExpireOn,
      is_unpaid_booking,
      is_outside_pay_later_cutoff,
    } = this.props;
    const { zero_priced_tour, selectedPaymentType, isPayLaterSelected } =
      this.state;
    const { request } = initial_summary_props;
    const affiliatePayLaterCheckout = is_affiliate && is_unpaid_booking;
    const checkoutPageCssClasses = classnames(
      'CheckoutPage CheckoutMobileFirstPage',
      {
        'is-live': this._isLiveBooking(),
      }
    );
    const confirmationCssClasses = classnames('ConfirmationContainer', {
      'is-live': this._isLiveBooking(),
    });

    const { title, sub_title } = kiosk_setting || {};
    let liveHeader = request.tour_name_translation;
    let liveSubHeader = `${t('WITH')} ${partner_info.business_name}`;

    if (title && title.trim() !== '') {
      liveHeader = title;
      liveSubHeader = sub_title;
    }

    const showBookingTimer = !isBookingInvoice && !this._isLiveBooking();

    return (
      <QueryProvider>
        <div>
          {this._renderPartnerHeader()}
          {this._isLiveBooking() && this.getEnabledLanguages().length > 0 && (
            <LanguageHeader>
              <LanguageSelector
                value={this.languageValue()}
                options={this.languageOptions()}
                onChange={this.onLanguageChange}
                styles={{ container: () => ({ width: '100%' }) }}
              />
            </LanguageHeader>
          )}
          <div className={checkoutPageCssClasses}>
            <Dimmer fixed transparent loader active={this._renderLoading()} />
            {this.props.show_translate && this._renderGoogleTranslate()}
            {showBookingTimer && <Header />}

            <div className="MobileFirstColumnContainer">
              <div className="ComponentContainer MobileFirstColumn">
                {/* Checkout timeout error setup - mobile-first (20 minutes) - do not timeout booking invoices */}
                {showBookingTimer && (
                  <BookingTimer
                    sessionExpired={willExpireOn}
                    tourId={tour_id}
                    guideId={guide_id}
                    originUrl={origin_url}
                  />
                )}
                {this._isLiveBooking() && (
                  <div>
                    <h3>{liveHeader}</h3>
                    <p>{liveSubHeader}</p>
                  </div>
                )}
                {this._shouldShowPersonalSection() && (
                  <PersonalInformation {...this._personalProps()} />
                )}
                {is_affiliate &&
                  zero_priced_tour !== null &&
                  !this._shouldShowPersonalSection() &&
                  !this._shouldShowPayment() && (
                    <div className="AffiliateFreeBookingMessage">
                      {t('AFFILIATE_FREE_BOOKING_NOTICE')}
                    </div>
                  )}
                {this._shouldCollectGuestInfo() && !isBookingInvoice && (
                  <GuestInformation
                    stepNo={2}
                    {...this._additionalGuestsProps()}
                  />
                )}

                {this._shouldShowPayment() && !this._shouldDisablePayment() && (
                  <div>
                    <PaymentStepHeader
                      stepNumber={this._paymentSectionStepNumber()}
                      showPersonalSection={this._shouldShowPersonalSection()}
                    />
                    {this._shouldShowPayLater() && (
                      <AffiliatePaymentSelector
                        paymentType={selectedPaymentType}
                        paymentTypeChanged={this._onSelectPaymentType}
                        disabledOptions={
                          !is_outside_pay_later_cutoff ? ['pay-later'] : []
                        }
                      />
                    )}
                    {this._paymentSubtext()}
                    {!isPayLaterSelected && (
                      <Payment
                        bookingRequestId={this.props.booking_request_id}
                        totalPriceCents={Math.round(this.state.total * 100)}
                        currency={this.state.currency}
                        {...this._formProxyProps('payment', {
                          guide_us_only: request.guide_us_only,
                          payment_subtext: request.payment_subtext,
                          is_booking_invoice: isBookingInvoice,
                          managedAccountToken: managed_account_token,
                          stripeTheme: stripe_theme,
                          googleTagManagerCheckoutProgress:
                            this._googleTagManagerCheckoutProgress,
                        })}
                      />
                    )}
                  </div>
                )}
                {!this._shouldDisableDiscount() && (
                  <Discount {...this._discountProps()} />
                )}
                {this._shouldShowAdditionalInfo() &&
                  !affiliatePayLaterCheckout && (
                    <AdditionalInformation
                      {...this._formProxyProps(
                        'additional_information',
                        this._additionalInformationProps()
                      )}
                    />
                  )}
              </div>
              {!this._isLiveBooking() && (
                <div className="ComponentContainer MobileFirstSummaryColumn">
                  <Summary {...this._summaryProps()} />
                </div>
              )}
            </div>
            {!this._isLiveBooking() && !is_affiliate && (
              <div className="ComponentContainer">
                <MessageGuide {...this._messageGuideProps()} />
              </div>
            )}
            <div className={confirmationCssClasses}>
              {this._shouldValidatePrivacyPolicy() && (
                <PrivacyPolicy {...this._privacyPolicyProps()} />
              )}
              {this._renderSubmitButton()}
              <p className="hint confirmation-subtext">
                {this.props.initial_summary_props.request.confirmation_subtext}
              </p>
              {!this.state.loading && (
                <PoweredBy hidePolicyLinks={this.state.hide_policy_links} />
              )}
            </div>
          </div>
          {this.state.errors.get('stripePaymentError') &&
            this.renderPaymentError()}
          {this.state.errors.get('invalidAddonError') &&
            this.renderAddonsError()}
        </div>
      </QueryProvider>
    );
  },
});

export default MobileFirstCheckoutPage;
